import React from 'react';
import '../styles/ServiceCard.css';

/**
 * ServiceCard
 * Props:
 *  num         {string}   – "01", "02" ...
 *  icon        {string}   – emoji
 *  name        {string}
 *  description {string}
 *  onEnquire   {function} – navigate to contact
 */
const ServiceCard = ({ num, icon, name, description, onEnquire }) => (
  <div className="service-card">
    <div className="service-card__num">{num}</div>
    <div className="service-card__icon">{icon}</div>
    <div className="service-card__name">{name}</div>
    <div className="service-card__desc">{description}</div>
    <button className="service-card__link" onClick={onEnquire}>
      Enquire Now →
    </button>
  </div>
);

export default ServiceCard;